<template>
  <div class="scroll-container">
    <div class="scroll-content">
      <!-- 滚动列表 -->
      <div class="scroll-item" v-for="(item, index) in totalList" :key="index">
        <img class="item-img" :src="`${img}headimg${index}.png`" alt="头像" />
        <span class="item-text">{{ item }}</span>
      </div>
      <!-- 无缝复制一份 -->
      <div class="scroll-item" v-for="(item, index) in totalList" :key="`a${index}`">
        <img class="item-img" :src="`${img}headimg${index}.png`" alt="头像" />
        <span class="item-text">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarqueeRoll",
  props: {
    img: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // 自动生成 11 个随机手机号（对应 headimg0~10.png）
      totalList: this.generateRandomPhones(11)
    }
  },
  methods: {
    // 生成 N 个随机手机号
    generateRandomPhones(count) {
      let list = []
      for (let i = 0; i < count; i++) {
        // 生成 11 位手机号，中间 6 位打码
        const prefix = this.getRandomNum(130, 199)
        const suffix = this.getRandomNum(1000, 9999)
        list.push(`${prefix} **** ${suffix}  1分钟前领取成功`)
      }
      return list
    },
    // 生成指定范围随机数
    getRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>

<style scoped>
.scroll-container {
  width: 100%;
  height: 24px;
  overflow: hidden;
  position: relative;
}

.scroll-content {
  display: inline-block;
  white-space: nowrap;
  animation: scroll 16s linear infinite;
}

.scroll-item {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #FFFFFF;
 background: rgba(44,44,44,0.46);
  border-radius: 12px;
 
  display: inline-flex;
  align-items: center; /* 图片上下绝对居中 */
  justify-content: center;
  padding: 0 10px;
  margin-right: 12px;
  box-sizing: border-box;
}

/* 头像样式 + 间距 */
.item-img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 6px; /* 图片右边间距 */
}

.item-text {
  flex-shrink: 0;
}

@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-30%); }
}
</style>